<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="原库位号/目标库位号..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              variant="outline-success"
              class="ml-2"
              @click="exportData"
            >
              <i class="el-icon-folder-opened"></i>
              导出
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="550px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
          <el-form-item label="原库位号">
            <el-col :span="24">
              <el-input
                v-model="form.oldLocationNo"
                clearable
                size="small"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="目标库位号">
            <el-col :span="24">
              <el-input
                v-model="form.locationNo"
                clearable
                size="small"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="操作人">
            <el-col :span="24">
              <el-input
                v-model="form.optByName"
                clearable
                size="small"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="操作类型">
            <el-col :span="12">
              <el-radio-group v-model="form.optType">
                <el-radio-button label="I">入柜</el-radio-button>
                <el-radio-button label="O">出柜</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="操作时间">
            <el-col :span="11">
              <el-date-picker
                v-model="form.startOptByTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :picker-options="dateStartPicker"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="form.endOptByTime"
                type="date"
                size="small"
                :picker-options="dateEndPicker"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: "",
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      dateStartPicker: this.dateEnd(),
      dateEndPicker: this.dateStart(),
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query() {
      this.$emit("query", this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ""
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    exportData() {
      this.$emit("exportData")
    },
    //时间限制
    dateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endOptByTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endOptByTime).getTime() < time.getTime()
          }
        },
      }
    },
    dateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.startOptByTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.startOptByTime).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
